import React, { Component } from 'react';
import { Form , Spin, Row, Col, Table} from 'antd';
// import { Link } from 'react-router-dom'
import { Pie } from 'react-chartjs-2';
import './css/style.css';
import logo from './img/logo.png';
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import {HeaderContainer, BoxTableContainer, ChartContainer, TableContainer} from '../pages/styled-components/index';

class Chart extends Component {
  state={
    event:[]
  }
  componentWillReceiveProps(nextProps) {
    const { eventBySlug = [] } = nextProps.data
    const orderedEvents = [eventBySlug]
    const donationBykilo = eventBySlug.donationBykilo
    const sumDistance = eventBySlug.sumDistance
    const total = sumDistance * donationBykilo
    const donationAllshirt = eventBySlug.donationAllshirt
    const totalDistance = eventBySlug.totalDistance
    this.setState({
      event: orderedEvents
    })
    this.setState({
      chartData:{
        labels: ['ยอดบริจาคเสื้อ(บาท)', 'ยอดบริจาคการวิ่ง(บาท)', 'ระยะทางวิ่งทั้งหมด(Km)'],
        datasets:[
          {
            label:'Population',
            data:[
              donationAllshirt,
              total,
              totalDistance
            ],
            backgroundColor:[
              'rgba(255, 99, 132, 0.6)',
              'rgba(54, 162, 235, 0.6)',
              'rgba(255, 206, 86, 0.6)',
            //   'rgba(75, 192, 192, 0.6)',
            //   'rgba(153, 102, 255, 0.6)',
            //   'rgba(255, 159, 64, 0.6)',
            //   'rgba(255, 99, 132, 0.6)'
            ]
          }
        ]
      }
    })
  }
    render() {
      if(!this.props.data.eventBySlug){
        return <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'100vh' }}>
        <Spin tip="Loading..."/>
        </div>
      }   
      const { event } = this.state
      const {eventBySlug} = this.props.data
      const title = eventBySlug.title
      const columns = [{
        title: 'Event',
        dataIndex: 'title',
        fixed: 'left',
        width: 160,
        key: 'event',
      }, {
        title: 'ยอดบริจาคเสื้อ(บาท)',
        dataIndex: 'donationAllshirt',
        key: 'donationAllshirt',
        render:(donationAllshirt)=>{
          const donationshirt  =parseFloat(donationAllshirt).toLocaleString();
          return donationshirt
        }
      }, {
        title: 'ยอดบริจาคการวิ่ง(บาท)',
        // dataIndex: 'sumDistance',
        key: 'sumDistance',
        render:(sumDistance, donationBykilo)=>{
          const total = eventBySlug.sumDistance*eventBySlug.donationBykilo
          const all  =parseFloat(total.toFixed(2)).toLocaleString();
          return all
        }
      }, {
        title: 'ระยะทางวิ่งทั้งหมด(Km)',
        dataIndex: 'totalDistance',
        key: 'totalDistance',
        render:(totalDistance)=>{
          const Distance  =parseFloat(totalDistance.toFixed(2)).toLocaleString();
          return Distance
        }
      }];
        return (
              <div>
                <Row>
                  <Col style={{marginTop:'100px'}} /> 
                  <Col className="header">
                    <HeaderContainer>
                      <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start'}}>
                        <img src={logo} alt="logo" />
                        <a href="/event" className='backhome'>
                          <strong>Event</strong>
                        </a>
                        <a href="/comprehendEvent" className='backhome'>
                          <strong>Report</strong>
                        </a>
                      </div>  
                    </HeaderContainer>   
                  </Col>
                </Row>
                <BoxTableContainer>
                  <ChartContainer>  
                    <Pie
                      data={this.state.chartData}
                      options={{ 
                        title:{
                          display: true,
                          text:'Event '+title,
                          fontSize: 25
                        },
                        legend:{
                          display: true,
                          position: 'bottom'
                        }
                      }}
                    />
                  </ChartContainer>    
                </BoxTableContainer>
                <BoxTableContainer style={{marginTop:'40px'}}>
                  <TableContainer>
                    <Table rowKey='_id' columns={columns} dataSource={event} pagination={{ pageSize: 50 }} scroll={{ x: 728 }}/> 
                  </TableContainer>
                </BoxTableContainer>
              </div>
    );
  }
}

// export default (Complete);
const queryevents = gql`
  query queryevents($slug: String!){
    eventBySlug(slug: $slug) {
      _id
      slug
      thumbnailUrl
      title
      startDate
      endDate
      totalDistance
      sumDistance
      modalContent
      donationAllshirt
      donationBykilo
    }
  }`

export default compose(
    Form.create() ,
    graphql(queryevents, {
        options: props => ({
          variables: {
            slug: props.match.params.slug
          }
        })
      }),
  )(Chart);





// WEBPACK FOOTER //
// ./src/components/pages/chart.js